@let permissionState = $permissionState();
@let permissionsForm = $permissionsForm();
@if (permissionState) {
  <form class="general-form" [formGroup]="permissionsForm" (ngSubmit)="onSave()">
    <input type="hidden" [formControl]="permissionsForm.controls.role_mask_set" [value]="permissionState.role_mask_set" />
  </form>
  <table>
    <th>Permission</th>
    @let permissionTypeNames = permissionTypes | sort;
    @for (type of permissionTypeNames; track $index) {
      <th>{{ type }}</th>
    }
    @for (kvp of permissionState.role_mask_set | keyvalue; track kvp) {
      @let entitlement = kvp.key;
      @let maskValue = kvp.value;
      <tr>
        <td>{{ entitlement }}</td>
        @for (typeName of permissionTypeNames; track typeName) {
          @let type = permissionType(typeName);
          @let blocked = controlBlocked(entitlement, type);
          @let cellClass = type === undefined || blocked === true ? 'icon-cell' : '';
          <td [class]="cellClass">
            @if (blocked === true) {
              <kendo-svg-icon size="xxlarge" title="Locked By Parent Role" [icon]="permissionUnavailableIcon" />
            } @else if (!type) {
              <kendo-svg-icon size="xxlarge" title="Entitlement Unavailable" [icon]="entitlementUnavailableIcon" />
            } @else {
              <kendo-switch
                [disabled]="switchboardEnabled !== true"
                [id]="entitlement + typeName"
                [checked]="bitEnabled(typeName, maskValue)"
                (valueChange)="onSwitch(entitlement, type, $event)" />
            }
          </td>
        }
      </tr>
    }
  </table>
}
